import { type FC, type ReactNode } from "react";

import { cn } from "@/shared/lib/utils";

const maxWidthClasses = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl",
  "3xl": "max-w-3xl",
  "4xl": "max-w-4xl",
} as const;

interface FullLayoutProps {
  children: ReactNode;
  maxWidth?: keyof typeof maxWidthClasses;
  verticalCenter?: boolean;
}

export const FullLayout: FC<FullLayoutProps> = ({
  children,
  maxWidth = "lg",
  verticalCenter = false,
}) => {
  return (
    <div
      className={cn("h-full overflow-y-auto overflow-x-hidden", verticalCenter && "flex flex-col")}
    >
      <div
        className={cn(
          "flex justify-center px-4 pb-12 sm:px-6 sm:pb-16",
          verticalCenter ? "my-auto" : "pt-6 sm:pt-10",
        )}
      >
        <div className={cn("w-full", maxWidthClasses[maxWidth])}>{children}</div>
      </div>
    </div>
  );
};
